/** HTTP status of a failed request (axios error, or a VanillaException carrying status/statusCode) */
export function errorStatus(error: unknown): number | undefined {
    const value = error as { response?: { status?: number }; status?: number; statusCode?: number } | null;
    return value?.response?.status ?? value?.status ?? value?.statusCode;
}
